import { render, staticRenderFns } from "./ApuracaoContratoFiltros.vue?vue&type=template&id=5b0d0a60&scoped=true"
import script from "./ApuracaoContratoFiltros.vue?vue&type=script&lang=js"
export * from "./ApuracaoContratoFiltros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0d0a60",
  null
  
)

export default component.exports